import { Component } from '@angular/core';


export class SkyTabsDemoComponent {
  public tabs: any[];
  public tabsWithCounts: any[];
  public activeTabIndex: any = 0;

  constructor() {
    this.tabs = [
      {
        heading: 'Tab 1',
        content: 'Content 1',
        active: true
      },
      {
        heading: 'Tab 2',
        content: 'Content 2'
      },
      {
        heading: 'Tab 3',
        content: 'Content 3'
      }
    ];
    this.tabsWithCounts = [
      {
        heading: 'Records',
        content: 'Placeholder content for records',
        headerCount: 10,
        active: true
      },
      {
        heading: 'Gifts',
        content: 'Placeholder content for gifts',
        headerCount: 14
      },
      {
        heading: 'Users',
        content: 'Placeholder content for users',
        headerCount: 144
      }
    ];
  }

  public closeClick(tabIndex: number) {
    this.tabs.splice(tabIndex, 1);
  }

  public newTabClick() {
    let nextTab = this.tabs && this.tabs.length + 1;

    this.tabs.push({
      heading: 'Tab ' + nextTab,
      content: 'Content ' + nextTab,
      active: true
    });
  }

  public openTabClick() {
    alert('You clicked the open tab button');
  }

  public tabChanged(newIndex: any) {
    console.log('new active', this.activeTabIndex);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tabs-demo',
  template: `<sky-tabset
  (newTab)="newTabClick()"
  (openTab)="openTabClick()"
  [active]="activeTabIndex"
  (activeChange)="tabChanged($event)">
  <sky-tab
    *ngFor="let tab of tabs; let i = index"
    [tabHeading]="tab.heading"
    (close)="closeClick(i)">
    {{tab.content}}
  </sky-tab>
  <sky-tab
    tabHeading="Permanent tab"
    tabIndex="permanent">
    This tab cannot be closed.
  </sky-tab>
</sky-tabset>

<h3>
  Tabs example with counter
</h3>

<sky-tabset
  [active]="0">
  <sky-tab
    *ngFor="let tab of tabsWithCounts"
    [tabHeading]="tab.heading"
    [tabHeaderCount]="tab.headerCount">
    {{tab.content}}
  </sky-tab>
</sky-tabset>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
